import format from 'date-fns/format'

export const getFormattedDate = (date: string, formatString: string) => {
	return new Date(date) ? format(new Date(date), formatString) : ''
}
